define('ArtworkUpload.Model', [
    'Backbone',
    'Utils'
], function (
    Backbone,
    Utils
) {
    'use strict';

    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                'services/ArtworkUpload.Service.ss'
            )
        ),

        // Uploads a single file as base64 JSON (multipart isn't reliably
        // supported through the extension-mechanism service proxy). Returns a
        // promise resolving to { fileId, url, name, type }.
        uploadFile: function (file) {
            var self = this;
            return new Backbone.$.Deferred(function (deferred) {
                var reader = new FileReader();

                reader.onerror = function () {
                    deferred.reject({ responseJSON: { errorMessage: 'Could not read the selected file.' } });
                };

                reader.onload = function () {
                    var dataUrl = reader.result || '';
                    var base64 = dataUrl.substring(dataUrl.indexOf(',') + 1);

                    self.save({
                        filename: file.name,
                        contentType: file.type || 'application/octet-stream',
                        size: file.size,
                        base64: base64
                    }, {
                        success: function (model, response) {
                            deferred.resolve((response && response.data) || response);
                        },
                        error: function (model, jqXhr) {
                            deferred.reject(jqXhr);
                        }
                    });
                };

                reader.readAsDataURL(file);
            }).promise();
        }
    });
});
